let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jNiCm")).then(() => parcelRequire('2oyZ3'));